import { Flex, IconButton, Text } from '@sparrowengg/twigs-react';
import { CloseCircleFillIcon } from '@sparrowengg/twigs-react-icons';
import { customPillVaraints } from 'commons/constants';
import { CustomPillProps } from 'commons/types';

const CustomPill = ({
  label,
  onCloseHandler,
  variant,
  radius,
  isClosable = true,
  icon
}: CustomPillProps) => {
  const { DEFAULT, ACCENT, SECONDARY, SUCCESS, WARNING, INFO } =
    customPillVaraints;

  const handleCurrentVariant = () => {
    switch (variant) {
      case DEFAULT:
        return {
          background: 'rgba(100, 116, 139, 0.08)',
          color: '$secondary800'
        };
      case SUCCESS:
        return {
          background: 'rgba(74, 156, 166, 0.15)',
          color: '$primary800'
        };
      case WARNING:
        return {
          background: '$warning100',
          color: '$warning700'
        };
      case ACCENT:
        return {
          background: '$accent100',
          color: '$accent500'
        };
      case SECONDARY:
        return {
          background: '#E5F2FF',
          color: '#0472EE'
        };
      case INFO:
        return {
          background: '#DCEBFF',
          color: '#1E62D0'
        };
    }
  };

  const isDefaultVariant = variant === DEFAULT;

  return (
    <Flex
      alignItems="center"
      css={{
        height: '$6',
        background: handleCurrentVariant()?.background,
        padding: '$2',
        paddingLeft: radius === 'sm' ? '$3' : '$2',
        borderRadius: radius === 'sm' ? '$sm' : '99px'
      }}
    >
      {!!icon && icon}
      <Text
        size="xs"
        weight="medium"
        css={{
          color: handleCurrentVariant()?.color,
          paddingInline: '$1'
        }}
      >
        {label}
      </Text>
      {isClosable && (
        <IconButton
          css={{
            padding: '$1',
            height: '$4',
            width: '$4',
            background: 'transparent !important',
            '.twigs-button__icon-container': { position: 'static' }
          }}
          variant="ghost"
          color={isDefaultVariant ? 'default' : 'primary'}
          onClick={onCloseHandler}
          icon={<CloseCircleFillIcon size={12} />}
        />
      )}
    </Flex>
  );
};

export default CustomPill;
